import React from "react";
import { Select } from "antd";

export default function ChartPanel(props) {
    const selectLabel = props.selectLabel || "Este periodo";
    return (
        <div className="chart-panel">
            <div className="chart-panel-header">
                <span className="chart-panel-title">{props.title}</span>
            
            </div>
            {props.children}
        </div>
    );
}
